const style = {
  leftContainer: {
    padding: '20px 40px 40px',
  },
}
export default style
